import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/failed-frame.svg'
import _imports_1 from '@/assets/data-missing-frame.svg'
import _imports_2 from '@/assets/waiting-frame.svg'
import _imports_3 from '@/assets/success-frame.svg'


const _hoisted_1 = { class: "w-full flex items-center justify-center my-[24px]" }
const _hoisted_2 = { class: "flex flex-col items-center gap-5" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "Failed"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "Data missing"
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  alt: "Waiting"
}
const _hoisted_6 = {
  key: 3,
  src: _imports_3,
  alt: "Success"
}
const _hoisted_7 = { class: "flex flex-col items-center" }
const _hoisted_8 = { class: "text-primary-text-color text-[24px] leading-[26px] tracking-[0.01rem] font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "text-primary-text-color text-[24px] leading-[26px] tracking-[0.01rem] font-bold"
}



type Props = {
  status?: string;
  title: string;
  subTitle?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireFinalScreen',
  props: {
    status: {},
    title: {},
    subTitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (__props.status === 'failed')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (__props.status === 'data-missing')
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (__props.status === 'waiting')
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.title), 1),
        (__props.subTitle)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(__props.subTitle), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})